// Migrated from app/assets/javascripts/red.coffee
// Red layout: login/logout, seatplan clicks, promo codes, modals, Safari storage access

import 'jquery'

(function() {
  if (!window.parent) return;
  var hasNotified = false;

  function notifyParentOfNavigation() {
    if (hasNotified) return;
    // AT-1118: red2 scrollt de ouderpagina ná het laden in plaats van ervoor, zie
    // libraries/red2-scroll.js. Op beforeunload scrolt de klantsite namelijk terwijl de
    // nieuwe pagina er nog niet is: je ziet eerst een sprong en daarna pas de navigatie,
    // twee losse bewegingen. De oude Red houdt dit gedrag.
    if (document.body && document.body.classList.contains('red2')) return;
    if (typeof window.parentIFrame === 'undefined' || window.parentIFrame == null) return;
    hasNotified = true;
    window.parentIFrame.sendMessage({
      type: 'scrollToTopOfIframe',
      offsetY: -50
    });
  }

  window.addEventListener('beforeunload', notifyParentOfNavigation);
  window.addEventListener('pagehide', notifyParentOfNavigation);

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      notifyParentOfNavigation();
    }
  });
})();

$(function() {
  var searchParams = new URLSearchParams(window.location.search);

  var safariMsgState = searchParams.get("safari_login_message");

  if (safariMsgState === 'show') {
    if (searchParams.get('friend_code_modal') === '1') {
      $('#safariLoginMsg .modal-body p').text(
        'Voor het activeren van uw vriendencode is goedkeuring van uw browser vereist voor het gebruik van cookies. Zonder deze goedkeuring werkt de vriendencode niet. Verwacht een melding van uw browser bij het activeren.'
      );
    }

    $('#safariLoginMsg').on('show.bs.modal', function(e) {
      $(e.target).find('.btn').click(function(e) {
        var url = searchParams.get("return_url") + '?&safari_login_message=shown';

        if (searchParams.get("loginpage") != null) {
          url += '&loginpage=' + searchParams.get("loginpage");
        }

        window.location.replace(url);
      });
    });
    $('#safariLoginMsg').modal({ backdrop: 'static', keyboard: false, show: true });
  }

  $('#seatplan').click(function(e) {
    $('.loading').show();

    var scaleRatio = this.naturalWidth / this.width;
    var offsetX = $(this).offset().left;
    var offsetY = $(this).offset().top;

    var clickX = Math.round(((e.pageX - offsetX) * scaleRatio) + offsetX);
    var clickY = Math.round(((e.pageY - offsetY) * scaleRatio) + offsetY);

    var body = $("body");
    var performanceId = body.data().hash.performance_id;
    var uuid = $(this).data('uuid');

    $.ajax("/shopping_cart/update_seating_coordinates?uuid=" + uuid, {
      type: "POST",
      data: {
        x: clickX - offsetX,
        y: clickY - offsetY,
        performance_id: performanceId
      }
    }).done(function(data, _textStatus, jqXHR) {
      // 200 OK met een van de oude string-waarden
      if (data === 'success') {
        window.location.reload(false);
        return;
      }

      if (data === 'EXPIRED') {
        window.location.href = '/agenda';
        return;
      }

      // oude "failed_*" codes -> user message
      var message;
      switch (data) {
        case 'failed_no_seats_in_range':
          message = 'Geen stoelen gevonden.';
          break;
        case 'failed_no_seats_with_matching_rank':
          message = 'Geen stoelen met de juiste rang gevonden.';
          break;
        case 'failed_too_few_seats_available_on_this_row':
          message = 'Te weinig stoelen beschikbaar op deze plek.';
          break;
        case 'failed_selection_keeps_one_single_seat_free':
          message = 'Uw keuze laat 1 stoel vrij, dit is niet mogelijk. Kies een andere plaats.';
          break;
        case 'SEAT_TAKEN':
          message = 'Deze stoel is net door iemand anders geclaimd. Kies een andere plaats.';
          break;
        default:
          message = "Onbekende waarde: " + data;
      }

      toastr.warning(message);
      $('.loading').hide();
      $('.overlay').show();
      setTimeout(function() { $('.overlay').hide(); }, 150);

    }).fail(function(jqXHR, _textStatus, _errorThrown) {
      var status = jqXHR != null ? jqXHR.status : undefined;
      var body = ((jqXHR != null ? jqXHR.responseText : undefined) || '').toString();

      // Nieuwe status-gestuurde paden
      if (status === 410 || body === 'EXPIRED') {
        window.location.href = '/agenda';
        return;
      }

      if (status === 409) {
        if (body.indexOf('SEAT_TAKEN') === 0) {
          toastr.warning('Deze stoel is net door iemand anders geclaimd. Kies een andere plaats.');
        } else if (body.indexOf('OUT_OF_STOCK') === 0) {
          var parts = body.split(':');
          var available = parts[1] != null ? parts[1] : null;
          var msg = available != null ? ("Niet genoeg stoelen beschikbaar (" + available + " over).") : 'Niet genoeg stoelen beschikbaar.';
          toastr.warning(msg);
        } else {
          toastr.warning('Je selectie kon niet worden geplaatst. Probeer een andere plek.');
        }
        $('.loading').hide();
        $('.overlay').show();
        setTimeout(function() { $('.overlay').hide(); }, 150);
        return;
      }

      if (status === 404) {
        toastr.error('Deze voorstelling of stoel kon niet worden gevonden.');
      } else if (status === 422) {
        toastr.error('Je selectie kon niet worden verwerkt.');
      } else {
        alert('Excuus, er is een onverwachte fout opgetreden [update_seating_coordinates].');
      }

      $('.loading').hide();
      $('.overlay').hide();
    });
  });

  // single shot link
  $('a.single-shot').one('click', function() {
    $('.overlay').show();
    $('.loading').show();
  });

  // password forgotten handler
  $('#password-forgotten-submit').click(function(e) {
    var email = $('#email2').val();
    var submitBtn = $(this);
    var spinner = submitBtn.find('.spinner-border');

    if (email.length === 0) {
      showErrorMessage('Geen e-mailadres opgegeven.', 'danger', $('#email2'));
      return;
    }

    submitBtn.attr('disabled', 'disabled');
    spinner.removeClass('d-none');

    $.ajax({
      url: "/api/v2/customers/password_forgotten",
      type: "POST",
      data: { email: email },
      dataType: "json"
    }).always(function() {
      submitBtn.removeAttr('disabled');
      spinner.addClass('d-none');
      $('#email1').val('');
    }).done(function(data) {
      if (data.result === true) {
        $('#login').modal('hide');
        showErrorMessage('Er is een e-mail naar het opgegeven e-mailadres verzonden.', 'success', $('#alert-box'));
      } else {
        showErrorMessage('Opgegeven e-mailadres is onbekend.', 'danger', $('#email2'));
      }
    }).fail(function() {
      showErrorMessage('Excuus, er is een onverwachte fout opgetreden.', 'danger', $('#email2'));
    });
  });

  // login handler
  $('#login-submit').click(function(e) {
    var email = $('#email1').val();
    var password = $('#password1').val();
    var remember_me = $('#persistent-login').prop("checked");
    var submitBtn = $(this);
    var spinner = submitBtn.find('.spinner-border');

    if (email.length === 0 || password.length === 0) {
      var carrouselActive = $('#carouselModal > .carousel-inner > .active');
      showErrorMessage('E-mail en/of wachtwoord leeg.', 'danger', carrouselActive.find('input').first());
      return;
    }

    submitBtn.attr('disabled', 'disabled');
    spinner.removeClass('d-none');

    $.ajax({
      url: "/api/v2/customers/login",
      type: "POST",
      xhrFields: {
        withCredentials: true
      },
      data: {
        email: email,
        password: password,
        remember_me: remember_me
      },
      dataType: "json"
    }).always(function() {
      submitBtn.removeAttr('disabled');
      spinner.addClass('d-none');
      $('#email1').val('');
      $('#password1').val('');
    }).done(function(data) {
      if (data.result === true) {
        var carrouselActive = $('#carouselModal > .carousel-inner > .active');
        showErrorMessage('U bent succesvol ingelogd.', 'success', carrouselActive.find('input').first());

        if (window.self !== window.top) {
          $('#edit_customer').attr('href', $('#edit_customer').attr('href') + '?return_to=' + window.location.href);
        }

        setTimeout(function() {
          document.cookie = "storage-access=true; expires=" + new Date(new Date().getTime() + 29 * 24 * 60 * 60 * 1000).toUTCString() + "; path=/";

          if (window.parentIFrame) {
            parentIFrame.sendMessage({
              type: 'login',
              customer_auth_token: data.customer_auth_token,
              remember_me: data.remember_me
            });
          }

          if (window.location.href.includes("bestel/gegevens")) {
            setTimeout(function() {
              $('form#details').submit();
            }, 500);
            return;
          }

          if ($('#login').length > 0 && $('#login').hasClass('modal') === true) {
            $('#login').modal('hide');
            $('#login-and-out').html(data.html);
            window.location.reload();
          } else {
            window.location.reload();
          }
        }, 1000);

      } else {
        var carrouselActive = $('#carouselModal > .carousel-inner > .active');
        showErrorMessage('Onjuiste inlog gegevens.', 'danger', carrouselActive.find('input').first());
      }
    }).fail(function() {
      var carrouselActive = $('#carouselModal > .carousel-inner > .active');
      showErrorMessage('Excuus, er is een onverwachte fout opgetreden.', 'danger', carrouselActive.find('input').first());
    });
  });

  function showErrorMessage(msg, type, target) {
    var wait = 0;
    var alertBox = $("<div class='shop-alert alert alert-" + type + " text-center w-100' role='alert'>" + msg + "</div>").hide();

    if (target.length > 0) {
      if ($(target).parent().find('.shop-alert').length > 0) {
        wait = 300;
        $(target).parent().find('.shop-alert').fadeOut(300, function() { $(this).remove(); });
      }

      setTimeout(function() {
        alertBox.insertBefore(target).fadeIn(300);
      }, wait);
    } else {
      toastr.info(msg);
    }
  }

  // login link handler
  $('.login-link').on('click', function(e) {
    // For safari, check if you came back from the first party by checking the session storage.
    if (isSafari() && !sessionStorage.getItem("safari_message_shown") && getCookieValue("customer_auth_token") === '' && getCookieValue("storage-access") === '') {
      var returnUrl, url;
      if (window.parent) {
        returnUrl = sessionStorage.getItem('avayoReturnUrl');
        url = new URL(returnUrl);
        returnUrl = url.origin + url.pathname + '?request_uri=' + encodeURIComponent(location.pathname + location.search);
      }

      var urlParams = new URLSearchParams(window.location.search);
      urlParams.set('safari_login_message', 'show');
      urlParams.set('return_url', returnUrl);

      if ($(e.target).data('page') != null) {
        urlParams.set('loginpage', $(e.target).data('page'));
      }

      url = window.location.origin + window.location.pathname;
      window.top.location.replace(url + '?' + urlParams.toString());
    } else {
      handleCookieAccessInit().then(function(result) {
        if (result === 'hasAccess') {
          $('#login').modal('show');
          setTimeout(function() {
            $('#email1').focus();
          }, 250);
        }

        if (result === 'hasNoAccess') {
          $('#safari-declined-popup .modal-title').text('Het gebruiken van cookies voor het inloggen');
          $('#safari-declined-popup').modal('show');
        }
      });
    }
  });

  // friend-code-link handler: in Safari + iframe is de ticketshop een third-party
  // context en blokkeert ITP de session-cookie, waardoor session[:friends_exclusive]
  // verloren gaat na het invullen van de code. Spiegel het patroon van .login-link:
  // eerst (zonder gezien-marker) naar first-party context loodsen, daarna altijd
  // via requestStorageAccess() om Safari toestemming te laten geven. Buiten
  // Safari/iframe: standaard href volgen.
  $('.friend-code-link').on('click', function(e) {
    if (!isSafari() || window.self === window.top) return;

    e.preventDefault();
    var targetHref = $(this).attr('href');

    if (!sessionStorage.getItem("safari_message_shown") && getCookieValue("storage-access") === '') {
      var avayoReturnUrl = sessionStorage.getItem('avayoReturnUrl');
      var returnUrl;
      if (avayoReturnUrl) {
        var parsed = new URL(avayoReturnUrl);
        returnUrl = parsed.origin + parsed.pathname + '?request_uri=' + encodeURIComponent(targetHref);
      } else {
        returnUrl = targetHref;
      }

      // friend_code_modal markeert deze flow zodat de safari-modal de juiste tekst
      // toont. We gebruiken bewust GEEN loginpage parameter: de embed-script in
      // public/javascripts/ticketshop.js interpreteert loginpage als iframe-pad
      // (iframe.src = getDomain() + '/' + loginPage), wat na de modal-cyclus zou
      // leiden tot een 404 op /friend-code.
      var urlParams = new URLSearchParams(window.location.search);
      urlParams.set('safari_login_message', 'show');
      urlParams.set('return_url', returnUrl);
      urlParams.set('friend_code_modal', '1');

      var topUrl = window.location.origin + window.location.pathname;
      window.top.location.replace(topUrl + '?' + urlParams.toString());
      return;
    }

    handleCookieAccessInit().then(function(result) {
      if (result === 'hasAccess') {
        window.location.href = targetHref;
      } else {
        $('#safari-declined-popup .modal-title').text('Het gebruiken van cookies voor uw vriendencode');
        $('#safari-declined-popup').modal('show');
      }
    });
  });

  // Activeer-formulier op /login: in Safari + iframe vragen we Storage Access
  // bij submit, zodat de POST naar /login_validation met cookies kan slagen
  // (anders raakt session[:friends_exclusive] direct daarna weer kwijt). Buiten
  // Safari/iframe of als toegang al verleend is: laat de submit normaal lopen.
  $('#formLogin').on('submit', function(e) {
    if (!isSafari() || window.self === window.top) return;
    if (getCookieValue("storage-access") !== '') return;

    e.preventDefault();
    var form = this;

    handleCookieAccessInit().then(function(result) {
      if (result === 'hasAccess') {
        document.cookie = "storage-access=true; expires=" +
          new Date(new Date().getTime() + 29 * 24 * 60 * 60 * 1000).toUTCString() +
          "; path=/";
        form.submit();
      } else {
        $('#safari-declined-popup .modal-title').text('Het gebruiken van cookies voor uw vriendencode');
        $('#safari-declined-popup').modal('show');
      }
    });
  });

  // logout handler
  $('#login-and-out').on('click', '#logout-link', function(e) {
    $.ajax({
      url: "/api/v2/customers/logout",
      type: "DELETE",
      xhrFields: {
        withCredentials: true
      },
      dataType: "json"
    }).done(function(data) {
      sessionStorage.removeItem("safari_message_shown");

      showErrorMessage('U bent succesvol uitgelogd.', 'success', $('#alert-box'));
      $('#login-and-out').html(data.html);
      setTimeout(function() {
        window.location.reload();
      }, 500);
    }).fail(function() {
      showErrorMessage('Excuus, er is een onverwachte fout opgetreden.', 'danger', $('#alert-box'));
    });
  });

  function removeSearchParam(param) {
    var newUrl = window.location.href.replace(new RegExp("[?&]" + param + "=[^&]*"), '');
    window.history.replaceState({}, document.title, newUrl);
  }

  if (searchParams.get("edit_account")) {
    showErrorMessage('Uw account gegevens zijn succesvol aangepast.', 'success', $('#alert-box'));
    removeSearchParam('edit_account');
  }

  if (searchParams.get("password_reset")) {
    showErrorMessage('Uw wachtwoord is succesvol aangepast.', 'success', $('#alert-box'));
    removeSearchParam('password_reset');
  }

  $('#order_ideal_issuer_id').change(function(e) {
    $('#order_payment_method_10').prop('checked', true);
  });

  // handle remote loading of modal content
  $(document).off('click.modal_link').on('click.modal_link', '.modal_link', function(e) {
    var remoteUrl = $(this).attr('href');
    var targetModal = $(this).data('target');
    var $modal = $(targetModal);

    // wis eventuele oude inline 'top' (van eerdere bug-versie) zodat
    // de iframe-resizer niet alsnog op een groot bottom-getal komt
    $modal.css('top', '');

    $modal.find('.modal-content').load(remoteUrl, function() {
      $modal.modal('show');
    });

    // in iframe-modus: scroll parent naar bovenkant van het iframe zodat
    // de (position:fixed) modal — die op ~30px van iframe-top hangt — in
    // beeld komt. Anders ziet de gebruiker alleen de backdrop.
    if (window !== window.top && window.parentIFrame) {
      window.parentIFrame.sendMessage({
        type: 'scrollToTopOfIframe',
        offsetY: 0
      });
    }
  });

  $('#viewport-width').val($(window).width());

  function showEmptyEventsMsg() {
    if ($('.event-item:visible').length === 0) {
      $('.no_tickets_msg').removeClass('d-none');
    } else {
      $('.no_tickets_msg').addClass('d-none');
    }
  }

  // month filter on index page
  $('#month_selector').on('change', function(e) {
    if ($(this).val() === "") {
      $('.month_wrapper').show();
    } else {
      $('.month_wrapper').hide();
      $('.' + $(this).val()).show();
    }
    showEmptyEventsMsg();
  });

  $('#genre_selector').on('change', function(e) {
    if ($(this).val() === "") {
      $('.event-item').show();
    } else {
      $('.event-item').hide();
      $('.month_wrapper').find('.event-item[data-genre=' + $(this).val() + ']').show();
    }
    showEmptyEventsMsg();
  });

  // enable tooltips
  $('[data-toggle="tooltip"]').tooltip();

  // ------------------------------------------------------------------------------------
  // section for nicer confirm dialogs
  // http://www.pjmccormick.com/nicer-rails-confirm-dialogs-and-not-just-delete-methods
  $.rails.allowAction = function(link) {
    if (!link.attr('data-confirm')) { return true; }
    $.rails.showConfirmDialog(link);
    return false; // always stops the action since code runs asynchronously
  };

  $.rails.confirmed = function(link) {
    link.removeAttr('data-confirm');
    link[0].click();

    $('.overlay').show();
    $('.loading').show();
  };

  $.rails.showConfirmDialog = function(link) {
    var message = link.attr('data-confirm');
    bootbox.confirm(message, function(result) {
      if (result) {
        $.rails.confirmed(link);
      }
    });
  };

  if (typeof Storage !== "undefined" && Storage !== null) {
    try {
      $('#avayo_parent_url').val(sessionStorage.getItem('avayoReturnUrl'));
    } catch (e) {
      // no action
    }
  }

  // disable paste on customer_email_confirm
  window.onload = function() {
    var myInput = document.getElementById('customer_email_confirm');
    if (myInput != null) {
      myInput.onpaste = function(e) {
        e.preventDefault();
      };
    }
  };
});
